import { Space, Tag, Typography } from 'antd';
import type { AiPageContext } from '@/utils/aiPageContextFromPath';

const { Text } = Typography;

export function ContextBadge({ pageContext }: { pageContext: AiPageContext }) {
  const mod = pageContext.module || '—';
  const hasDoc = pageContext.docType && pageContext.docId;
  const selCount = pageContext.selection?.ids?.length ?? 0;
  return (
    <Space size={6} wrap>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Page
      </Text>
      <Tag color="blue">{mod}</Tag>
      {hasDoc ? (
        <Tag>
          {pageContext.docType} <Text type="secondary" code children={pageContext.docId} />
        </Tag>
      ) : (
        <Tag>General</Tag>
      )}
      {selCount > 0 ? (
        <Tag color="geekblue">
          {selCount} selected
          {pageContext.selection?.entityType ? ` · ${pageContext.selection.entityType}` : ''}
        </Tag>
      ) : null}
    </Space>
  );
}
